import { Col, Container, Row } from "reactstrap";
import { FooterClassMap, FooterDescription, FooterDetailData } from "../../../data/layout/Footer";
import { dynamicImage, Image } from "../../../utils";
import UsePathName from "../../../utils/UsePathName";
import FooterInfo from "../common/FooterInfo";
import FooterBranding from "../common/FooterBranding";
import FooterSearch from "./FooterSearch";

const FooterDemo2 = () => {
  const FooterData = FooterDetailData.slice(2, 5).reverse();
  const [Path] = UsePathName();

  return (
    <footer className={`job3-footer ${FooterClassMap[Path || ""]}`}>
      <Container>
        {!Path?.includes("job-2") && <FooterSearch />}
        <div className="dark-job-footer">
          <Row className="justify-content-between gy-lg-0 gy-sm-4 gy-3">
            <Col lg="4">
              <FooterBranding description={FooterDescription[1]} endPoint={4} />
            </Col>
            <FooterInfo data={FooterData} />
          </Row>
        </div>
        <div className="copyright-box">
          <p className="text-white">@ 2025 All Rights Reserved</p>
          <Image src={dynamicImage("dark-job/payment-img.png")} alt="payment-img" className="img-fluid" />
        </div>
      </Container>
    </footer>
  );
};

export default FooterDemo2;
